import { Component } from '@angular/core';

@Component({
  selector: 'app-snackbar-content-layout',
  templateUrl: './snackbar-content-layout.component.html',
  styleUrls: ['./snackbar-content-layout.component.scss']
})
export class SnackbarContentLayoutComponent {

}
